/**
 * @readonly
 * @enum {string}
 *
 * List of all configured custom coupling rules with specific configuration (coupling to force or to ignore ) for a
 * given account.
 * FORCE is a custom coupling rule which was forced to couple one specific vehicle to specific asset. IGNORE is a custom
 * coupling rule which forcing to ignore coupling between specific vehicle to asset.
 */
export const CustomCouplingRuleTypeEnum = Object.freeze({
    FORCE_COUPLING: 'FORCE_COUPLING',
    IGNORE_COUPLING: 'IGNORE_COUPLING'
})
